import React from 'react'
import { Navigate, Outlet, UIMatch, useLocation, useMatches } from 'react-router-dom'

import { RouteHandle, UserPermissions } from '../../types.ts'
import { APP_ROUTES, PERMISSION_ROUTES_MAP } from '../../constants.ts'
import { useUser } from '@/stores/slices/user-slice.ts'

export const PermissionCheck = (): React.ReactElement | null => {
  const user = useUser()
  const matches = useMatches() as UIMatch<unknown, RouteHandle<any>>[]
  const { pathname } = useLocation()
  const matchIdx = matches.findIndex(({ pathname: matchPathname }) => matchPathname === pathname)
  const { permissionKey } = matches[matchIdx].handle ?? {}

  if (!user?.id) {
    // пока не загрузили пользователя, нет смысл делать проверку пермишенов
    return null
  }

  if (!permissionKey) {
    // если для роута не задан permissionKey в router.tsx,
    // то по умолчанию нам сюда можно
    console.info(`no permission needed for [${permissionKey}, ${pathname}]`)
    return <Outlet />
  }

  const userGotPermission =
    permissionKey instanceof Array
      ? // @ts-expect-error keys are validated in route
        Object.entries<UserPermissions>(user.permissions).some(([key, value]) => permissionKey.includes(key) && !!value)
      : user.permissions[permissionKey]

  if (userGotPermission) {
    console.info(`got permission [${permissionKey}, ${pathname}]`)
    return <Outlet />
  }

  console.info(`Has no permissions for ${pathname}, looking for available page...`)
  const [availablePage] = Object.entries(user.permissions).find(([, isAllowed]) => isAllowed) ?? []
  const availableAppRoutes = PERMISSION_ROUTES_MAP[availablePage as keyof UserPermissions]

  if (!availablePage || !availableAppRoutes?.length) {
    console.info(
      `No available pages or no available app route found for user permissions! [${permissionKey}, ${availablePage}, ${availableAppRoutes}]`
    )
    return <Navigate to={APP_ROUTES.Login} />
  }

  console.info('Navigating to available page', availablePage)
  return <Navigate to={availableAppRoutes[0]} />
}
